import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../utils/UtilsUrl";

class BCService {
  addBC(bc) {
    return api.post(UtilsUrl.bcURL() + "/addBonCommande", bc);
  }
  getRefBC() {
    return api.get(UtilsUrl.bcURL() + "/getRefBC");
  }

  getBCAndExrats(idBC) {
    return api.get(UtilsUrl.bcURL() + "/getBCEndExtratID/" + idBC);
  }
  validateBC(idBC) {
    return api.get(UtilsUrl.bcURL() + "/validateBC/" + idBC);
  }
  deleteBCDraft(idBC) {
    return api.get(UtilsUrl.bcURL() + "/deleteBCDraft/" + idBC);
  }

  getBCById(idBC) {
    return api.get(UtilsUrl.bcURL() + "/getBCById/" + idBC);
  }
  getMaxAmountBC(idBC) {
    return api.get(UtilsUrl.bcURL() + "/getMaxAmountBC/" + idBC);
  }

  payerEspeceAvanceBC(payement) {
    return api.post(UtilsUrl.bcURL() + "/payerEspeceAvanceBC", payement);
  }

  payerVirementAvanceBC(payement) {
    return api.post(UtilsUrl.bcURL() + "/payerVirementAvanceBC", payement);
  }

  payerChequeAvanceBC(payement) {
    return api.post(UtilsUrl.bcURL() + "/payerChequeAvanceBC", payement);
  }
  payerEnLigneAvanceBC(payement) {
    return api.post(UtilsUrl.bcURL() + "/payerEnLigneAvanceBC", payement);
  }
  listAvancePayementBC(idBC) {
    return api.get(UtilsUrl.bcURL() + "/getAvancesPayementBC/" + idBC);
  }

  //modified

  getListBCSociete(idSociete, isPayed, isDeleted) {
    return api.get(
      `/retail/document/getImpayedAndAvailableBDC/${idSociete}/${isPayed}/${isDeleted}`
    );
  }

  getDocumentForPayementTask(idDocument, isFactureOrBDC) {
    let currentUser = currentUserId();
    return api.get(
      `/retail/document/getDocumentForPayementTask/${currentUser}/${parseInt(
        idDocument
      )}/${isFactureOrBDC}`
    );
  }
  getFacturePayementInformation(idFacture, typeDocument) {
    let currentUser = currentUserId();
    return api.get(
      "/retail/payement/getFacturePayementInformation/" + currentUser + "/" + parseInt(
        idFacture
      ) + "/" + typeDocument
    );
  }

  getListAvancePayementBDC(idDocument) {
    let currentUser = currentUserId();
    return api.get(
      `/retail/payement/getListAvancePayementBDC/${currentUser}/${parseInt(
        idDocument
      )}`
    );
  }

  payFactureOrBDC(payFactureOrAvance) {
    payFactureOrAvance.idUser = currentUserId();

    return api.post("/retail/payement/payFactureOrBDC", payFactureOrAvance);
  }
  PayRejeterPayementInfo(payementModel) {
    return api.post("/retail/payement/PayerAndRejeterPayement", payementModel);
  }
  acceptOrRejectBorderau(payementModel) {
    return api.post("/retail/payement/acceptOrRejectBorderau", payementModel);
  }



  getFactureRetenueExistance(retenuExistanceModel) {
    retenuExistanceModel.idUser = currentUserId();

    return api.post(
      "/retail/payement/getFacturesRetenueExistance",
      retenuExistanceModel
    );
  }

  generateRetenuSource(idUser, percentRetenu, idDocument) {
    console.log("percentRetenu ws", percentRetenu)
    return api.get(
      "/retail/payement/generateRetenu/" + idUser + "/" + percentRetenu + "/" + idDocument
    );
  }
  finaliserPayement(typeDocument, idDocument) {
    console.log("idDocument", idDocument);
    return api.get(
      "/retail/payement/finaliserPayement/" + idDocument + "/" + typeDocument
    );
  }

  generateRetenuSourceV2(idUser, percentRetenu, amountRetenu, idDocument) {
    return api.get(
      "/retail/payement/generateRetenuV2/" + idUser + "/" + percentRetenu + "/" + amountRetenu + "/" + idDocument
    );
  }
  changeExchangeRatePayement(idUser, idFacture, TauxChange, devise, finalPriceHTC, finalPriceTTC) {
    return api.get(
      "/retail/document/changeExchangeRatePayement/" + idUser + "/" + idFacture + "/" + TauxChange + "/" + devise + "/" + finalPriceHTC + "/" + finalPriceTTC
    );
  }
}
export default new BCService();
